import React from "react";
import { AdSubCategoryTypesTable } from "../../UI/AdSubCategoryTypes/AdSubCategoryTypesTable";
import PanelBody from "../../UI/Panel/PanelBody";
import PanelHead from "../../UI/Panel/PanelHead";

const AdSubCategoryTypes = () => {
  return (
    <div>
      <PanelHead title="AdSubCategoryTypes" />
      <PanelBody content={<AdSubCategoryTypesTable />} />
    </div>
  );
};

export default AdSubCategoryTypes;
